import {
  BillingContact,
  billingContactSchema,
} from '@/pages/enterprise/_data/payment-billing-contact-schema'
import { useState } from 'react'
import { z } from 'zod'
import BillingContactEditDialog from './billing-contact-edit'

interface ContactCardProps {
  billingContact: z.infer<typeof billingContactSchema>
  billingContacts: BillingContact[]
  onDelete?: (billingContactId: z.infer<typeof billingContactSchema>) => void
  onEdit?: (billingContact: BillingContact) => void
}

export default function ContactCard({
  billingContact,
  onDelete,
  billingContacts,
  onEdit,
}: ContactCardProps) {
  const [openEdit, setOpenEdit] = useState(false)
  return (
    <>
      <div className="border rounded-lg shadow-sm p-4 flex items-center justify-between  transition-all hover:shadow-md">
        <div>
          <h3 className="font-medium text-foreground line-clamp-1	">
            {billingContact.firstName} {billingContact.lastName}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-1">
            {billingContact.email}{' '}
          </p>
        </div>
        <div className="flex flex-wrap gap-4">
          {onEdit && (
            <div
              className="!p-0 !py-0 bg-transparent text-primary/80 font-normal cursor-pointer transition-colors hover:text-primary/80"
              onClick={() => setOpenEdit(true)}
            >
              Edit
            </div>
          )}
          {onDelete && (
            <div
              className="!p-0 !py-0 bg-transparent text-[#EF3826] font-normal cursor-pointer transition-colors hover:text-[#EF3826]/80"
              onClick={() => onDelete && onDelete(billingContact)}
            >
              Delete
            </div>
          )}
        </div>
      </div>

      <BillingContactEditDialog
        open={openEdit}
        onOpenChange={setOpenEdit}
        billingContact={billingContact}
        billingContacts={billingContacts}
        onSubmitDone={(value) => onEdit && onEdit(value)}
      />
    </>
  )
}
